export default __webpack_public_path__ + "static/media/file-type-blank-icon.e6d63066.svg";